import { useEffect, useState } from 'react';
import { prefersReducedMotion } from './subscriptionAccessibility';

export { LEARNER_UI_ANIM_MS } from './learnerUiAnim';
/** Floating Farsi keyboard panel — same cadence as learner slide modals. */
export { LEARNER_UI_ANIM_MS as FLOATING_KEYBOARD_ANIM_MS } from './learnerUiAnim';
/** Backdrop opacity fade — keep in sync with modal motion in index.css (180ms). */
export const MODAL_BACKDROP_FADE_MS = 180;

/** Same reveal cadence as {@link FarsiKeyboardInput} floating keyboard (effect + single rAF). */
export function useFloatingKeyboardSlideReveal(active: boolean, onReveal: () => void): void {
  useEffect(() => {
    if (!active) return undefined;
    if (prefersReducedMotion()) {
      onReveal();
      return undefined;
    }
    const id = requestAnimationFrame(() => onReveal());
    return () => cancelAnimationFrame(id);
  }, [active, onReveal]);
}

/** Fade backdrop in/out with learner slide modals (opacity transition on `.keyboard-slide-modal-backdrop`). */
export function useModalBackdropFade(mounted: boolean, exiting: boolean): boolean {
  const [backdropVisible, setBackdropVisible] = useState(false);

  useEffect(() => {
    if (!mounted || exiting) {
      setBackdropVisible(false);
      return undefined;
    }
    if (prefersReducedMotion()) {
      setBackdropVisible(true);
      return undefined;
    }
    setBackdropVisible(false);
    const id = requestAnimationFrame(() => setBackdropVisible(true));
    return () => cancelAnimationFrame(id);
  }, [mounted, exiting]);

  return backdropVisible;
}
